import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import * as ctEvents from '../../events/Events';
import { getSEOFriendlyURL } from '../../utilities/Utils';

const style = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
  },
  image_wrapper: {
    height: '100px',
    width: '100px',
    padding: '10px',
    marginBottom: '4px',
  },
  title: {
    width: '80px',
    height: '40px',
    margin: '0 auto',
    textAlign: 'center',
    whiteSpace: 'break-spaces',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    fontSize: '15px',
    lineHeight: '20px',
    fontWeight: '700',
  },
};

const CategoryThumb = ({ category, page }) => {
  const getShopCategoryUrl = (cat) => {
    if (cat.id === 0) {
      return '/shops';
    }
    return `shops/c/${getSEOFriendlyURL(cat.name)}-${cat.id}`;
  };

  return (
    <Link
      to={getShopCategoryUrl(category)}
      style={style.wrapper}
      onClick={() => {
        ctEvents.categoryClicked({
          SCREEN: page,
          CATEGORY_NMAE: category.description,
        });
      }}
    >
      <div style={style.image_wrapper}>
        <img className="w-100" src={category.image} alt={category.description} />
      </div>
      <div style={style.title}>{category.description}</div>
    </Link>
  );
};

CategoryThumb.propTypes = {
  category: PropTypes.shape({
    image: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  page: PropTypes.string.isRequired,
};

export default CategoryThumb;
